import React from 'react';

//Estilos
import './NewDJTV.css';
import TableContainer from '../../components/table/TableContainer';

function NewDJTV({ functions, states }) {
    const { tableData, DJTVData } = states;

    const { handleSubmit, onSubmit } = functions;

    return (
        <div className="newDJTV-container">
            <form className="newDJTV-form" onSubmit={handleSubmit(onSubmit)}>
                <h4>
                    {`Declaración Jurada de Transferencia de Viñedo ${DJTVData?.cabecera?.serie}-P-${DJTVData?.cabecera?.numero}${DJTVData?.cabecera?.viniedo}`}
                </h4>
                <TableContainer tableData={tableData} />
                <div className="newDJTV-footer">
                    <button
                        type="submit"
                        className="btn btn-primary btn-submit-newDJTV"
                    >
                        Guardar
                    </button>
                </div>
            </form>
        </div>
    );
}

export default NewDJTV;
